import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth.tsx';

interface NavItem {
  to: string;
  label: string;
  end?: boolean;
}

const NAV_ITEMS: readonly NavItem[] = [
  { to: '/app/jobs', label: 'Jobs' },
  { to: '/app/takeoff/rebar', label: 'Takeoff · Rebar' },
  { to: '/app/takeoff/civil', label: 'Takeoff · Civil' },
  { to: '/app/output', label: 'Output' },
  { to: '/app/training', label: 'Training' },
];

export function Shell() {
  const { user, signOut } = useAuth();

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '232px 1fr',
        minHeight: '100vh',
        background: '#070810',
        color: '#F0F2FF',
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      <aside
        style={{
          background: '#0D0F1C',
          borderRight: '1px solid rgba(255,255,255,0.07)',
          padding: '22px 18px',
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}
      >
        <div
          style={{
            fontFamily: "'Syne', sans-serif",
            fontWeight: 800,
            fontSize: 18,
            marginBottom: 22,
            letterSpacing: -0.4,
          }}
        >
          Otto<span style={{ color: '#00E87A' }}>Bid</span>
          <span style={{ color: '#C49BFF', fontWeight: 400 }}>.ai</span>
        </div>

        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            style={({ isActive }) => ({
              display: 'block',
              padding: '9px 12px',
              borderRadius: 6,
              fontSize: 13,
              color: isActive ? '#F0F2FF' : '#B8BDD6',
              background: isActive ? 'rgba(0,232,122,0.08)' : 'transparent',
              borderLeft: isActive ? '2px solid #00E87A' : '2px solid transparent',
              transition: 'background 120ms ease',
            })}
          >
            {item.label}
          </NavLink>
        ))}

        <div style={{ marginTop: 'auto', paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ fontSize: 11, color: '#525870', fontFamily: "'JetBrains Mono', monospace", marginBottom: 6 }}>
            SIGNED IN
          </div>
          <div style={{ fontSize: 12, color: '#F0F2FF', marginBottom: 10, wordBreak: 'break-all' }}>
            {user?.email ?? 'unknown'}
          </div>
          <button
            type="button"
            onClick={() => void signOut()}
            style={{
              fontSize: 11,
              color: '#B8BDD6',
              background: 'transparent',
              border: '1px solid rgba(255,255,255,0.12)',
              borderRadius: 5,
              padding: '6px 10px',
              fontFamily: "'JetBrains Mono', monospace",
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            Sign out
          </button>
        </div>
      </aside>

      <main style={{ padding: '32px 40px', overflowY: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
